module.exports = __webpack_public_path__ + "img/color-palette.ab6ce81d.png";